import baseErrorReport, { setConfig, trackApiEvent } from '@didi/error-base';

import { isMX } from '../utils/cluster';

import { ENV } from './env';
import errorCodeConfig from './errorcodeConfig.json';

// 应用ID（需要从稳定性平台获取）
const APPID = '6-80-104';

export const initErrorMonitor = (userId?: string) => {
    if (typeof ENV === 'object' && process.env.BUILD_ENV !== ENV.DEV) {
        // 初始化错误监控
        baseErrorReport(window.Omega, APPID, {
            consoleError: false,
            errorCodeConfig,
            cluster: isMX() ? 'mx' : 'us'
        });

        // 设置用户相关配置
        setConfig({
            userId
        });

        window.errorReportInit = true;
    }
};

export const getTraceIdFromResponse = (response: any): string => {
    try {
        const headerTraceId = response?.headers?.['header-trace-id'];
        const dataTraceId = response?.data?.['data-trace-id'];

        return headerTraceId || dataTraceId || '';
    } catch (error) {
        return '';
    }
};

export const createTrackDone = (
    url: string,
    params: Record<string, unknown>
) => {
    // 如果params是formData，则需要转换为对象
    const apiParams = params;

    if (!window.errorReportInit) {
        return () => {};
    }

    return trackApiEvent({ url }, apiParams, {
        errCode: ['errno', 'errorCode'],
        errMsg: ['errmsg', 'errorMsg'],
        successCode: [0, 10000],
        headerTraceIdKeys: ['colored-didi-header-rid']
    });
};
